import KunLoading42 from './src/index'

KunLoading42.install = function (Vue) {
	Vue.component(KunLoading42.name, KunLoading42);
}

export default KunLoading42;
